import React, { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from 'src/components/auth/context/AuthContextCp';


import { ErrorBoundary } from 'src/components/common/ErrorBoundary';
import { SuspenseLoader } from 'src/components/common/SuspenseLoader';


// Lazy load route components

const AppRoutes = lazy(() => import('./AppRoutes').then(m => ({ default: m.AppRoutes })));
const AuthRoutes = lazy(() => import('./AuthRoutes').then(m => ({ default: m.AuthRoutes })));


// Error pages
const NotFound = lazy(() => import('../components/errors/NotFound').then(m => ({ default: m.NotFound })));
const ServerError = lazy(() => import('../components/errors/ServerError').then(m => ({ default: m.ServerError })));
const Unauthorized = lazy(() => import('../components/errors/Unauthorized').then(m => ({ default: m.Unauthorized })));

export const AppRouter: React.FC = () => {

  return (
    <ErrorBoundary>
      <BrowserRouter >
        <AuthProvider>
          <SuspenseLoader>
           <Routes>
              {/* Public routes */}
              <Route path="/auth/*" element={<AuthRoutes />} />

              {/* Protected routes */}
              <Route path="/*" element={<AppRoutes />} />

              {/* Error routes */}
              <Route path="/errors">
                <Route path="404" element={<NotFound />} />
                <Route path="unauthorized" element={<Unauthorized />} />
                <Route path="server-error" element={<ServerError />} />
              </Route>

              {/* Global 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>

          </SuspenseLoader>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};